module.exports = __webpack_public_path__ + "static/media/categories_step_2_2.d58064b8.svg";